export const BUNITO_HISTORY_REQUEST = "BUNITO_HISTORY_REQUEST";
export const BUNITO_HISTORY_SUCCESS = "BUNITO_HISTORY_SUCCESS";
export const BUNITO_HISTORY_FAILED = "BUNITO_HISTORY_FAILED";